import React, { useEffect, useState } from "react";
import { Annonce } from "../../models/AnnonceModel";
import { getPromobyCode, PromoCode } from "../../services/codePromo_service";
import { toast } from "react-toastify";

interface AnnouncementStatusProps {
    annonce: Annonce
}

const AnnouncementStatus: React.FC< AnnouncementStatusProps > = ({ annonce }) => {

    const [ promoCode, setPromoCode ] = useState<PromoCode | null>( null )

    useEffect(() => {
        const getPromocode = async () => {
            try {
                const tempPromoCode = annonce.PromoCodeId ? await getPromobyCode( annonce.PromoCodeId?.toString() ) : null;
                setPromoCode( tempPromoCode );
            } catch (error: any) {
                toast.error(error.message || "Erreur lors de la récupération du code promo");
                setPromoCode(null);
            }
        }
        getPromocode();
    }, [])

    const montantTTC = parseFloat(String(annonce.montantTTC));
    const isFree     = montantTTC === 0;

    return(
        <>
            {
                promoCode
                    ?   <div style={{ fontWeight: 'bold', fontSize: '0.9em', color: '#ff9e28ff', marginBottom: '6px' }}>
                            - Remise de { promoCode.discountPercentage } %
                        </div>
                    :
                ( annonce.commission_percentage && annonce.commission_percentage != 0 )
                    ?   <div style={{ fontWeight: 'bold', fontSize: '0.9em', color: '#ff9e28ff', marginBottom: '6px' }}>
                            - Commission de { annonce.commission_percentage } %
                        </div>
                    :
                ( annonce.creditNoteAmount && annonce.creditNoteAmount != 0 )
                    ?   <div style={{ fontWeight: 'bold', fontSize: '0.9em', color: '#ff9e28ff', marginBottom: '6px' }}>
                            - avoir de { annonce.creditNoteAmount } €
                        </div>
                    :
                isFree
                    ?   <div style={{ fontWeight: 'bold', fontSize: '0.9em', color: '#28a745', marginBottom: '6px' }}>
                            Gratuit
                        </div>
                    :   <> </>
            
            }

        </>
    )
}

export default AnnouncementStatus